import type { CalendarDayEntry } from '../services/api';
import type { ATPWeek } from '../services/atpApi';

function number(value: unknown): number | null {
  if (value == null || value === '') return null;
  const n = Number(value);
  return Number.isFinite(n) && n >= 0 ? n : null;
}

/** Allocate weekly ATP targets over the visible dates; never use planned load as actual. */
export function calendarPlanMetrics(dates: string[], weeks: ATPWeek[], days: CalendarDayEntry[], today: string) {
  const visible = new Set(dates);
  let target = 0;
  let covered = false;
  for (const week of weeks) {
    let details;
    try { details = typeof week.details === 'string' ? JSON.parse(week.details) : week.details; } catch { details = null; }
    const tss = number(details?.tss) ?? number(week.volume);
    const start = new Date(`${week.start_day.slice(0, 10)}T12:00:00`);
    for (let i = 0; i < 7; i++) {
      const d = new Date(start);
      d.setDate(d.getDate() + i);
      const iso = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
      if (visible.has(iso) && tss != null) { target += tss / 7; covered = true; }
    }
  }
  let actual = 0;
  let missing = false;
  const seen = new Set<number>();
  const hydrated = new Set(days.map(day => day.day.slice(0, 10)));
  for (const day of days) {
    if (!visible.has(day.day.slice(0, 10)) || day.day.slice(0, 10) > today) continue;
    for (const w of day.workouts ?? []) {
      if (seen.has(w.id) || Number(w.workout_type?.id) === 7) continue;
      seen.add(w.id);
      const load = number(w.tss_actual);
      if (load != null) actual += load;
      else if ((number(w.total_time) ?? 0) > 0 || (number(w.distance) ?? 0) > 0) missing = true;
    }
  }
  return {
    planned: covered ? Math.round(target) : null,
    actual: missing || dates.some(d => !hydrated.has(d)) ? null : Math.round(actual),
  };
}
